import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";

export interface EmailTemplate {
    id: string;
    subject: string;
    body: string;
}

export default class EmailTemplateStore {
    templates: EmailTemplate[] = [];
    loading = false;

    layoutSettings: { header: string; footer: string } | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    fetchTemplates = async () => {
        this.loading = true;
        try {
            const templates = await agent.Emails.getTemplates();
            runInAction(() => {
                this.templates = templates;
            });
        } catch (error) {
            console.error("Failed to fetch templates:", error);
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    };

    createTemplate = async (template: Partial<EmailTemplate>) => {
        try {
            await agent.Emails.createTemplate(template);
            this.fetchTemplates();
        } catch (error) {
            console.error("Failed to create template:", error);
        }
    };

    updateTemplate = async (template: EmailTemplate) => {
        try {
            await agent.Emails.updateTemplate(template);
            this.fetchTemplates();
        } catch (error) {
            console.error("Failed to update template:", error);
        }
    };

    deleteTemplate = async (id: string) => {
        try {
            await agent.Emails.deleteTemplate(id);
            this.fetchTemplates();
        } catch (error) {
            console.error("Failed to delete template:", error);
        }
    };

    fetchLayoutSettings = async () => {
        try {
            const settings = await agent.Emails.getLayoutSettings();
            this.layoutSettings = settings;
            return settings;
        } catch (error) {
            console.error("Failed to fetch layout settings:", error);
            return null;
        }
    };

    saveLayoutSettings = async (settings: { header: string; footer: string }) => {
        try {
            await agent.Emails.saveLayoutSettings(settings);
            this.layoutSettings = settings;
        } catch (error) {
            console.error("Failed to save layout settings:", error);
        }
    };
}
